// extracted by mini-css-extract-plugin
export default {"smallMarginY":"F6LJQE2Fszvg9KVOmxmN","mediumMarginY":"BksgMOMHvrKfqAN2GB2u","largeMarginY":"jNEAlgMthUWhWIagk4_A"};